<template>
  <div
    class="react-template-preview"
    v-if="showReactPreview && !!selectedTemplateId"
  >
    <iframe
      v-if="selectedTemplateId"
      :key="selectedTemplateId"
      :src="`/preview/template/${selectedTemplateId}`"
      width="100%"
      height="100%"
      class="react-template-preview__iframe"
      frameborder="0"
    />
    <div class="react-template-preview__bar">
      <v-btn icon @click="closePreview">
        <v-icon>close</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionnaireReactPreview',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    templateId: {
      type: [String, Number],
      required: true,
      validator: value => value !== null && value !== undefined && value !== '',
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.showReactPreview = val;
      },
    },
    templateId: {
      immediate: true,
      handler(newVal) {
        this.selectedTemplateId = newVal;
      },
    },
  },
  computed: {
    isReleaseApp() {
      return (
        window &&
        window.location &&
        window.location.hostname === 'release.soraban.com'
      );
    },
  },
  data() {
    return {
      showReactPreview: this.value,
      selectedTemplateId: this.templateId,
    };
  },
  methods: {
    closePreview() {
      this.showReactPreview = false;
      this.$emit('input', false);
    },
  },
};
</script>

<style scoped="true">
.react-template-preview {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999;

  height: 100%;
  width: 100%;
}

.react-template-preview__bar {
  position: absolute !important;
  top: 0 !important;
  right: 0 !important;
  z-index: 9999 !important;

  align-items: center;
  display: flex;
  margin: 0 !important;
  padding: 0 8px !important;
  height: 56px;
  width: 100%;
  justify-content: flex-end;

  background-color: #f8f8f8;
}

.react-template-preview__iframe {
  background-color: white;
}
</style>
